/**
 * Three pulsing dots. Pure CSS (see .oa-typing-dots in globals.css): animates
 * continuously and independently of socket traffic, theme-able via currentColor,
 * and honors prefers-reduced-motion. (Browsers natively pause CSS animations in
 * hidden tabs, so no explicit visibility gate is needed.)
 */
export default function TypingDots(): JSX.Element {
  return (
    <span className="oa-typing-dots" aria-hidden="true">
      <i />
      <i />
      <i />
    </span>
  );
}
